<template>
    <div class="tags">
        <div
            v-for="item of options"
            :key="item.path"
            :class="['tags--item', active === item.active && 'tags--active']"
            @click="handleJump(item)"
        >
            <span>{{ item.name }}</span>
        </div>
    </div>
</template>
<script>
export default {
    props: {
        active: {
            type: String,
            default: 'ns-index'
        }
    },
    data() {
        return {
            options: []
        }
    },
    methods: {
        handleJump(target) {
            this.$emit('handleTitle', target.title)

            this.$router.push({ path: target.path })
        }
    },
    mounted() {
        const currScreenType = JSON.parse(
            sessionStorage.getItem('currScreenType')
        )
        this.options = [
            {
                path: `/${currScreenType.contents}/${currScreenType.key}`,
                name: '数据总览',
                title: `${currScreenType.label}农业设备装备一张图`,
                active: 'overview-data'
            },
            {
                path: `/${currScreenType.contents}/${currScreenType.key}/machinery-data`,
                name: '农机大数据',
                title: `${currScreenType.label}农机大数据`,
                active: 'machinery-data'
            },
            {
                path: `/${currScreenType.contents}/${currScreenType.key}/statistics-data`,
                name: '作业统计',
                title: `${currScreenType.label}农机作业统计`,
                active: 'statistics-data'
            }
        ]
    }
}
</script>
<style lang="scss" scoped>
.tags {
    position: absolute;
    display: flex;
    left: 15px;
    top: 55px;
    &--item {
        width: 130px;
        height: 28px;
        line-height: 28px;
        text-align: center;
        background-image: radial-gradient(
            circle at 50% 50%,
            #012245 0%,
            #0145a4 105%
        );
        color: #40c0ff;
        font-size: 18px;
        margin-right: 8px;
        border: 1px solid rgba(66, 154, 250, 0.28);
        transform: skew(-26deg);
        cursor: pointer;
        > span {
            display: inline-block;
            transform: skew(26deg);
        }
    }
    &--active {
        border: 1px solid rgba(66, 154, 250, 1);
        background-image: radial-gradient(
            circle at 48% 61%,
            #6cc3ff 0%,
            #00bcfc 36%
        );
        color: #003677;
    }
}
</style>
